export type ExtraInputFields = {
  extraInputEnabled?: boolean;
  extraInputDescription?: string | null;
  extraInputPrint?: boolean;
  extraInputRequired?: boolean;
  extraInputDigitsOnly?: boolean;
  extraInputLettersOnly?: boolean;
  extraInputMinLength?: number | null;
  extraInputMaxLength?: number | null;
};

export const defaultExtraInputFields: ExtraInputFields = {
  extraInputEnabled: false,
  extraInputDescription: "",
  extraInputPrint: false,
  extraInputRequired: false,
  extraInputDigitsOnly: false,
  extraInputLettersOnly: false,
  extraInputMinLength: null,
  extraInputMaxLength: null,
};

export function mapExtraInputFields(source?: ExtraInputFields | null): ExtraInputFields {
  return {
    extraInputEnabled: Boolean(source?.extraInputEnabled),
    extraInputDescription: source?.extraInputDescription ?? "",
    extraInputPrint: Boolean(source?.extraInputPrint),
    extraInputRequired: Boolean(source?.extraInputRequired),
    extraInputDigitsOnly: Boolean(source?.extraInputDigitsOnly),
    extraInputLettersOnly: Boolean(source?.extraInputLettersOnly),
    extraInputMinLength: source?.extraInputMinLength ?? null,
    extraInputMaxLength: source?.extraInputMaxLength ?? null,
  };
}
